// The copy keys for a box's ownership pairing, lifted out of `<BoxOwnerForm/>`
// the way `MACHINE_STATUS` is lifted into `lib/machine-labels.ts`: literal keys in
// a lookup, never an interpolated `t(\`…${kind}\`)`, so every key the bundle can
// render stays greppable — and one map, so a third ownership kind cannot be
// spelled one way in the picker and another in the sentence under it.

import type { RunnerOwnerKind } from '@developerz/domain';

/** The option label per ownership kind. */
export const OWNER_KIND_LABEL: Record<RunnerOwnerKind, string> = {
  org: 'fleet.panel.owner_kind_org',
  user: 'fleet.panel.owner_kind_user',
};

/** What that kind means for the work the box may claim. */
export const OWNER_KIND_DESC: Record<RunnerOwnerKind, string> = {
  org: 'fleet.panel.owner_desc_org',
  user: 'fleet.panel.owner_desc_user',
};
